import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import {
  detailActions,
  detailSelectors,
} from 'store/reducers/menuCategoryReducer/detailSlice';
import { useToast } from 'hooks/useToast';
import * as menuCategoryApi from 'api/menuCategoryApi';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import { useListStore } from './useListStore';
import { mapMenuCategoryToFormFields } from '../types/menuCategoryEditFormFields';

export const useDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchMenuCategories } = useListStore();
  const selectedMenuCategory = useAppSelector(
    detailSelectors.selectedMenuCategory,
  );
  const isOpenModal = useAppSelector(detailSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(detailActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteMenuCategory = useCallback(() => {
    if (selectedMenuCategory) {
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(detailActions.updateLoadingStatus(true));
        const result = await menuCategoryApi.deleteMenuCategory(
          selectedMenuCategory.id,
        );
        if (result.ok) {
          toast({
            status: 'success',
            description: `カテゴリーを削除しました。`,
          });

          onCloseModal();
          dispatch(detailActions.modalOpened(null));
          void fetchMenuCategories();
        } else {
          toast({
            status: 'error',
            description: `カテゴリーの削除に失敗しました。`,
          });
        }
        dispatch(detailActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `カテゴリーの削除に失敗しました。`,
        });
      });
    }
  }, [
    selectedMenuCategory,
    toast,
    dispatch,
    onCloseModal,
    fetchMenuCategories,
  ]);

  return {
    /** メニューカテゴリーの内容 */
    values: mapMenuCategoryToFormFields(selectedMenuCategory || {}),
    /** メニューカテゴリーの削除 */
    onDeleteMenuCategory,
    /** メニューカテゴリーの削除キャンセル */
    onCloseModal,
    /** メニューカテゴリー削除確認モーダルの表示状態 */
    isOpenModal,
  };
};
